export enum SopHubEntryId {
  DASHBOARD = "dashboard",
  ADD_CATEGORY = "add-category",
  ADD_PRODUCT = "add-product",
  ADD_PRODUCT_ITEM = "add-product-item",
  CREATE_ORDER = "create-order",
  MANAGE_ORDER = "manage-order",
  ISSUE_INVOICE = "issue-invoice",
  RECORD_PAYMENT = "record-payment",
  MANAGE_COMPANY = "manage-company",
  MANAGE_STORES = "manage-stores",
  MANAGE_PROFILE = "manage-profile",
  FORGOT_PASSWORD = "forgot-password"
}
